import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { ServicioToastService } from 'src/app/services/servicio-toast.service';
import EspecialidadEntity from 'src/app/classes/EspecialidadEntity';
import FiltrosHistoriaAdmisionEntity from 'src/app/classes/FiltrosHistoriaAdmisionEntity';
import EmpresasEntity from 'src/app/classes/EmpresasEntity';
import TratamientoAsistencialEntity from 'src/app/classes/TratamientoAsistencialEntity';

@Component({
  selector: 'app-header-admision',
  templateUrl: './header-admision.component.html',
  styleUrls: ['./header-admision.component.css']
})
export class HeaderAdmisionComponent implements OnInit, OnChanges {

  canLoad: boolean;
  canImpresion: boolean;
  loading: boolean;
  loadingImpresion: boolean;
  containsTriagge: boolean;

  especialidades: SelectItem[] = [];
  empresas: SelectItem[] = [];

  especialidadesSelected: number[] = [];
  empresasSelected: number[] = [];

  ttas: TratamientoAsistencialEntity[] = [];

  @Input() public filtros: FiltrosHistoriaAdmisionEntity;

  @Output() errores: EventEmitter<string>;
  @Output() filtrosSeleccionados: EventEmitter<FiltrosHistoriaAdmisionEntity>;

  constructor(private servicioFormato: ServicioFormatoAsistencialService,
              private servicioToast: ServicioToastService) {
    this.filtrosSeleccionados = new EventEmitter<FiltrosHistoriaAdmisionEntity>();
    this.errores = new EventEmitter<string>();
    this.servicioFormato.temporalNodos.subscribe((next: any) => {
      if (next) {
        const data: any[] = JSON.parse(next.data);
        if ( data && data.length > 0 ) {
          this.loadingImpresion = true;
        } else {
          this.loadingImpresion = false;
        }
      }
    })
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.loading = true;
    this.ttas = this.filtros.ttas;
    this.setImpresion();
    this.initTratamientos();
  }

  // Carga
  /*async getEspecialidades() {
    try {
      const request = await this.servicioFormato.getEspecialidadesByAdmision(this.filtros.codigoBaseDatos, this.filtros.uncoAdmision);
      if (request != null) {
        request.subscribe((especialidades: EspecialidadEntity[]) => {
          if (especialidades && especialidades.length > 0) {
            especialidades.forEach((e: EspecialidadEntity) => this.especialidades.push({ label : e.descripcion, value : e.unco}));
            this.getEmpresas();
          } else {
            // Error Especialidades
          }
        })
      }
    } catch (err) {
      console.error('HeaderAdmisionComponent.getEspecialidades()', err);
    }
  }

  async getEmpresas() {
    try {
      const request = await this.servicioFormato.getEmpresasByAdmision(this.filtros.codigoBaseDatos, this.filtros.uncoAdmision);
      if (request != null) {
        request.subscribe((empresas: EmpresasEntity[]) => {
          if (empresas && empresas.length > 0) {
            empresas.forEach((e: EmpresasEntity) => this.empresas.push({ label : e.getDescripcion(), value : e.unco}));
            this.loading = false;
            this.onAutoCompletarFiltros();
          } else {
            // Error Empresas
          }
        })
      }
    } catch (err) {
      console.error('HeaderAdmisionComponent.getEmpresas()', err);
    }
  }*/

  initTratamientos() {
    this.especialidades = [],
    this.empresas = [];
    if (this.ttas && this.ttas.length > 0) {
      this.ttas.forEach((tta: TratamientoAsistencialEntity) => {
        const especialidad = tta.historiaClinica.profesionalEspecialidad.especialidad;
        const empresa = tta.historiaClinica.afiliadoEmpresa.empresa;
        const isTriagge = tta.historiaClinica.sedePuntoAtencion.puntoAtencion.triagge;

        if (isTriagge){
          this.containsTriagge = true;
        }

        if (isTriagge) {
          if (this.filtros.triagge) {
            this.addEspecialidad(especialidad.unco, especialidad.descripcion);
            this.addEmpresa(empresa.unco, empresa.descripcionCorta);
          }
        } else {
          this.addEspecialidad(especialidad.unco, especialidad.descripcion);
          this.addEmpresa(empresa.unco, empresa.descripcionCorta);
        }
      });
      this.loading = false;
      this.onAutoCompletarFiltros();
    }
  }

  // Listener

  onAutoCompletarFiltros() {
    this.especialidadesSelected = [];
    this.empresasSelected = [];

    this.especialidades.forEach((e: SelectItem) => {
      this.especialidadesSelected.push(e.value);
    });

    this.empresas.forEach((e: SelectItem) => {
      this.empresasSelected.push(e.value);
    });

    this.onGenerar();
  }

  onGenerar() {
    if (!this.empresasSelected || this.empresasSelected.length === 0) {
      this.errores.emit('Debe seleccionar al menos una empresa.');
    } else if (!this.especialidadesSelected || this.especialidadesSelected.length === 0) {
      this.errores.emit('Debe seleccionar al menos una especialidad.');
    } else {
      this.filtros.ttasSelected = this.getTtasSelected(this.especialidadesSelected, this.empresasSelected);
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    const wait = this.servicioFormato.getTemporalWait();
    if (wait && wait.length > 0) {
      this.servicioToast.addError('El reporte aún no se encuentra listo, se esta procesando las siguientes preguntas: ' + wait.toUpperCase());
      return;
    }

    let printContents: any, popupWin: any;

    printContents = document.getElementById('historias-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <link href="https://fonts.googleapis.com/css?family=Gentium+Basic" rel="stylesheet">
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">
          <link rel="stylesheet" href="https://unpkg.com/ngx-bootstrap/datepicker/bs-datepicker.css">
          <link rel="stylesheet" href="assets/css/historia-print.css"/>
        </head>
        <body onload="window.print();window.close()">
        <table class="content-window">
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content"> ${ printContents } </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="header"></div>
        <div class="footer">
            <span class="page-count">&copy; 2021 - sqlsimens.com.co</span>
        </div>
        </body>
      </html>`
    );

    popupWin.document.close();
  }

  onFirma(value: boolean) {
    this.filtros.firma = value;
  }

  onDiligenciados(value: boolean) {
    this.filtros.diligenciados = value;
  }

  onOrden(value: boolean) {
    this.filtros.ordenCronologico = value;
  }

  onEvoluciones(value: boolean) {
    this.filtros.evoluciones = value;
  }

  onNotas(value: boolean) {
    this.filtros.notas = value;
  }

  onServicios(value: boolean) {
    this.filtros.solicitudServicios = value;
  }

  onTriagge(value: boolean) {
    this.filtros.triagge = value;
    this.initTratamientos();
  }

  // Auxiliares

  setImpresion() {
    this.canLoad = this.filtros.login.activaImpresion >= 1;
    this.canImpresion = this.filtros.login.activaImpresion === 2;

    this.filtros.canLoad = this.canLoad;
    this.filtros.canImpresion = this.canImpresion;
  }

  addEspecialidad(unco: number, descripcion: string) {
    if (this.especialidades.findIndex((e: SelectItem) => e.value === unco) == -1) {
      this.especialidades.push({ label : descripcion, value : unco});
    }
  }

  addEmpresa(unco: number, descripcion: string) {
    if (this.empresas.findIndex((e: SelectItem) => e.value === unco) == -1) {
      this.empresas.push({ label : descripcion, value : unco});
    }
  }

  getTtasSelected(especialidades: number[], empresas: number[]) {
    let ttas: TratamientoAsistencialEntity[] = [];

    ttas = this.ttas.filter((tta: TratamientoAsistencialEntity) => {

      const uncoEspecialidad = tta.historiaClinica.profesionalEspecialidad.especialidad.unco;
      const uncoEmpresa = tta.historiaClinica.afiliadoEmpresa.empresa.unco;

      const existEspecialidad: boolean = especialidades.includes(uncoEspecialidad);
      const existEmpresa: boolean = empresas.includes(uncoEmpresa);
      return existEspecialidad && existEmpresa;
    })

    return ttas;
  }

}
